/**
 * WordPress dependencies
 */

import { useSelect } from '@wordpress/data';
import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, ToggleControl } from '@wordpress/components';
import { SloganMemberLinkSettings } from '../../components/SloganMemberLinkSettings';

const Inspector = ({ attributes, setAttributes }) => {
	const { enableLink, postType } = attributes;

	// get post types: post, page, custom post type
	const postTypes = useSelect((select) => {
		const data = select('core').getEntityRecords('root', 'postType', {
			per_page: -1,
		});
		return data?.filter(
			(item) =>
				item.visibility.show_in_nav_menus && item.visibility.show_ui
		);
	});
	// get all posts, page or custom post types according to chosen post type
	const posts = useSelect(
		(select) => {
			const data = select('core').getEntityRecords(
				'postType',
				postType,
				{
					per_page: -1,
				}
			);

			return data;
		},
		[postType]
	);

	const handleEnableLink = (e) => {
		console.log(e);

		setAttributes({
			enableLink: e,
			postType: '',
			linkedPost: 0,
		});
	};

	return (
		<InspectorControls>
			<PanelBody title={__('Link', 'wtrb-boxslogan-block')}>
				<div style={{ display: 'flex' }}>
					<ToggleControl
						checked={enableLink}
						onChange={handleEnableLink}
					/>
					<span>{__('Enable Link', 'wtrb-boxslogan-block')}</span>
				</div>

				{enableLink && (
					<SloganMemberLinkSettings
						attributes={attributes}
						setAttributes={setAttributes}
						postTypes={postTypes}
						posts={posts}
					/>
				)}
			</PanelBody>
		</InspectorControls>
	);
};

export default Inspector;
